import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import Preload from "../common/Preload";

const PageLayout = () => {
  useEffect(() => {
    const mainWrapper = document.getElementById("main-wrapper");
    const hamburger = document.querySelector<HTMLElement>(".hamburger");
    const navControls = Array.from(document.querySelectorAll<HTMLElement>(".nav-control"));

    const handleToggle = () => {
      mainWrapper?.classList.toggle("menu-toggle");
      hamburger?.classList.toggle("is-active");
    };

    navControls.forEach((control) => {
      control.addEventListener("click", handleToggle);
    });

    return () => {
      navControls.forEach((control) => {
        control.removeEventListener("click", handleToggle);
      });
    };
  }, []);

  return (
    <>
      <Preload />
      <div id="main-wrapper">
        <Outlet />
      </div>
    </>
  );
};

export default PageLayout;
